function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M45.53 1.18H18.47A18.47 18.47 0 000 19.66v27.05a18.47 18.47 0 0018.47 18.47h27.06A18.47 18.47 0 0064 46.71v-27A18.47 18.47 0 0045.53 1.18zm12.58 46a12.26 12.26 0 01-12.27 12.27H18.16A12.26 12.26 0 015.89 47.19V19.5A12.26 12.26 0 0118.16 7.24h27.68A12.26 12.26 0 0158.11 19.5z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32 16.74a16.61 16.61 0 1016.61 16.6A16.61 16.61 0 0032 16.74zm0 27.37a10.77 10.77 0 1110.76-10.77A10.76 10.76 0 0132 44.11z"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 49.16,
  cy: 16.11,
  r: 3.87
});

function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Instagram",
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyBkYXRhLW5hbWU9Ikluc3RhZ3JhbSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNjQgNjQiPgogIDxwYXRoIGQ9Ik00NS41MyAxLjE4SDE4LjQ3QTE4LjQ3IDE4LjQ3IDAgMDAwIDE5LjY2djI3LjA1YTE4LjQ3IDE4LjQ3IDAgMDAxOC40NyAxOC40N2gyNy4wNkExOC40NyAxOC40NyAwIDAwNjQgNDYuNzF2LTI3QTE4LjQ3IDE4LjQ3IDAgMDA0NS41MyAxLjE4em0xMi41OCA0NmExMi4yNiAxMi4yNiAwIDAxLTEyLjI3IDEyLjI3SDE4LjE2QTEyLjI2IDEyLjI2IDAgMDE1Ljg5IDQ3LjE5VjE5LjVBMTIuMjYgMTIuMjYgMCAwMTE4LjE2IDcuMjRoMjcuNjhBMTIuMjYgMTIuMjYgMCAwMTU4LjExIDE5LjV6Ii8+CiAgPHBhdGggZD0iTTMyIDE2Ljc0YTE2LjYxIDE2LjYxIDAgMTAxNi42MSAxNi42QTE2LjYxIDE2LjYxIDAgMDAzMiAxNi43NHptMCAyNy4zN2ExMC43NyAxMC43NyAwIDExMTAuNzYtMTAuNzdBMTAuNzYgMTAuNzYgMCAwMTMyIDQ0LjExeiIvPgogIDxjaXJjbGUgY3g9IjQ5LjE2IiBjeT0iMTYuMTEiIHI9IjMuODciLz4KPC9zdmc+";
export { SvgInstagram as ReactComponent };